/**
 * Pôr um URL dentro de um `url(...)` de CSS sem o partir.
 *
 * `url(${x})` — sem aspas — é o que estava escrito nos dois sítios que desenham
 * a capa do perfil, e parte-se com um URL perfeitamente normal: o `)` de um
 * ficheiro chamado `foto (1).png` FECHA a função no meio do caminho, o valor
 * fica inválido e o browser DESCARTA a declaração inteira. Sem erro nenhum: a
 * capa simplesmente não aparece, e o resto do `style` (a posição) aplica-se na
 * mesma — o que faz parecer que o problema é a imagem.
 *
 * Foi assim que apareceu: um SVG de teste com `fill="url(#g)"` lá dentro deixou
 * o cartão vazio e o enquadramento a funcionar.
 *
 * Com aspas, só falta escapar as próprias aspas e as barras invertidas. Nada
 * mais é preciso: quebras de linha não sobrevivem a um URL, e o resto é texto.
 */
export function cssUrl(url: string): string {
  return `url("${url.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}")`;
}
